/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContractDetailsDtoApiResponse } from '../../models/contract-details-dto-api-response';
import { CreateCustomerTaxRegimeCommand } from '../../models/create-customer-tax-regime-command';

export interface CreateTaxRegimeCustomerAsync$Plain$Params {
  id: number;
      body?: CreateCustomerTaxRegimeCommand
}

export function createTaxRegimeCustomerAsync$Plain(http: HttpClient, rootUrl: string, params: CreateTaxRegimeCustomerAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ContractDetailsDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, createTaxRegimeCustomerAsync$Plain.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContractDetailsDtoApiResponse>;
    })
  );
}

createTaxRegimeCustomerAsync$Plain.PATH = '/api/customer/{id}/taxregime';
